import { Component, OnInit } from '@angular/core';
import { SelectionsErrorModel } from '@app/models/selections-model';
import { SharedService } from '@app/services/shared.service';
import { VennHealthUtils } from '../vennHealthUtils';
import { IndicationDefinition, IndicationGroup } from '@app/models/indication';
import * as _ from 'lodash';
// import { deepEqual } from 'assert';

@Component({
  selector: 'app-validation-summary',
  templateUrl: './validation-summary.component.html',
  styleUrls: ['./validation-summary.component.css']
})
export class ValidationSummaryComponent implements OnInit {

  validationErrors: SelectionsErrorModel[] = [];
  groupedValidationErrors = [];
  selectedFiltersFromLastRanQuery: IndicationDefinition[] = [];
  selectedDataSets: any = [];
  selectedDataSetsFromLastRanQuery: any = [];
  allIndications: IndicationGroup[] = [];
  querySelectionsHaveChanged = false;

  constructor(private readonly sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.validationErrors.subscribe(data => {
      if (data) {
        this.validationErrors = data;
        if (this.validationErrors.length > 0) {
          this.groupedValidationErrors = VennHealthUtils.formatGroupedByIntoKVPArray(this.validationErrors, 'indicationGroupDisplayName');
          //this.scrollToTop();
        }
      }
    });

    this.sharedService.allIndications.subscribe(data => {
      if (data) {
          this.allIndications = data;
          this.checkIfFiltersChanged();
        }
      }
    );

    this.sharedService.rawResultsData.subscribe(
      data => {
        if (data !== null) {
          // reset the changed flag
          this.querySelectionsHaveChanged = false;
          this.sharedService.setLastExecutedQueryInfo(data);
        }
      }
    );

    this.sharedService.lastExecutedQueryInfo.subscribe(data => {
      if (data) {
        this.selectedFiltersFromLastRanQuery = data['selectedFilters'];
        this.selectedDataSetsFromLastRanQuery = data['selectedDataSets'];
      }
    });

    this.sharedService.selectedDataSets.subscribe(data => {
      if (data) {
        this.selectedDataSets = data;
        this.checkIfFiltersChanged();
      }
    });

    this.sharedService.resetQuery.subscribe(reset => {
      if (reset) {
        this.selectedFiltersFromLastRanQuery = [];
        this.selectedDataSetsFromLastRanQuery = [];
        this.querySelectionsHaveChanged = false;
      }
    });
  }

  checkIfFiltersChanged() {
    this.querySelectionsHaveChanged = false;
    const currentIndicationSelected = [];
    const lastRanSelections = [];
    if (this.selectedFiltersFromLastRanQuery && this.selectedFiltersFromLastRanQuery.length > 0) {
        
      this.selectedFiltersFromLastRanQuery.sort((a,b) => this.alphabeticalSort(a.name, b.name)).forEach(filter => {
        if (filter.diagnosedOnly === true) {
          lastRanSelections.push(filter.name);
        } else {
          filter.selections.sort((a,b) => this.alphabeticalSort(a.indicationName, b.indicationName)).forEach(selection => {
            lastRanSelections.push(selection);
          });
        }
      });

      this.allIndications.sort((a,b) => this.alphabeticalSort(a.name, b.name)).forEach(group => {
        group.indications.sort((a,b) => this.alphabeticalSort(a.name, b.name)).forEach(ind => {
          if (ind.selected === true) {
            if (ind.diagnosedOnly === true) {
              currentIndicationSelected.push(ind.name);
            } else {
              ind.selections.sort((a,b) => this.alphabeticalSort(a.indicationName, b.indicationName)).forEach(selection => {
                currentIndicationSelected.push(selection);
              });
            }
          }
        });
      });

    }

    let currentDataSetsSelected = [];
    let lastRanDataSets = [];
    if (this.selectedDataSetsFromLastRanQuery && this.selectedDataSetsFromLastRanQuery.length > 0) {
      lastRanDataSets = this.selectedDataSetsFromLastRanQuery.map(i => i.value).sort();
      currentDataSetsSelected = this.selectedDataSets.map(i => i.value).sort();
    }
    
    this.querySelectionsHaveChanged = !_.isEqual(currentIndicationSelected, lastRanSelections) || !_.isEqual(currentDataSetsSelected, lastRanDataSets);

  }

  alphabeticalSort(a,b): any {
    var textA = a.toUpperCase();
    var textB = b.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  }

  // scrollToTop(): void {
  //   window.scroll({ 
  //     top: 0, 
  //     left: 0, 
  //     behavior: 'smooth' 
  //   });
  // }

}
